import Vue from 'vue'
import store from '../store'

class TasksService {

  constructor() {}

  get_logs(rec, me) {
    Vue.http.get('/api/projects/task-output?task_id=' + rec.item.id)
      .then(res => {
        me.logs = res.body[0]
      }, res => {
        me.$notify({
          title: 'ERROR',
          text: 'Could not load logs',
          type: 'error'
        })
        return ''
      })
  }
  loadScripts(me, clb) {
    Vue.http.get('/api/tasks/scripts', {
      params: {
        workpack_id: me.currentProject.workpack.id
      }
    })
      .then(res => {
        me.scripts = res.body
        clb && clb.call(me, me.scripts)
      }, res => {
        me.$notify({
          title: 'ERROR',
          text: 'Could not load scripts',
          type: 'error'
        })
      })
  }

  addTasks(me, payload) {
    Vue.http.post('/api/tasks/add-tasks', payload)
      .then(res => {
        me.$notify({
          title: 'SUCCESS',
          text: 'Tasks added. They will soon appear in the list',
          type: 'success'
        })
      }, res => {
        me.$notify({
          title: 'ERROR',
          text: 'Could not add tasks',
          type: 'error'
        })
      })
  }

}
export default TasksService



// WEBPACK FOOTER //
// ./src/service/tasks.js